import type { Customer, EntryPoint, Nullable } from 'corgi-types';

import { useLocalization } from 'common/providers/LocaleProvider';
import type { NavigationListProps } from '../types';
import { getNavigationItems, getUspEntryPoints } from '../utils';

interface UseNavigationItemsParams {
  customer: Nullable<Customer>;
  uspEntryPoints: EntryPoint[];
}

export const useNavigationItems = ({ customer, uspEntryPoints }: UseNavigationItemsParams) => {
  const l10n = useLocalization();

  let navigation = getNavigationItems({
    l10n,
    customer,
  });

  navigation = [...navigation, ...getUspEntryPoints(uspEntryPoints)];

  return navigation;
};

export const useShowPromoImage = ({
  navLevel,
  selectedItem,
  isDefaultTab = true,
}: Pick<NavigationListProps, 'navLevel' | 'selectedItem' | 'isDefaultTab'>) => {
  const promoNavLevel = isDefaultTab ? 2 : 1;

  return (
    (navLevel === 0 && selectedItem !== null) ||
    (navLevel === promoNavLevel && selectedItem === null)
  );
};
